import { Top } from "../class/Top.js";

export function upravStranku() {
  Lc.f("kategire.upravStranku");
  let $urlParams = new URLSearchParams(window.location.search);
  if ($urlParams.get("vypisKf")) {
    $("body").addClass("bdKatKF");
  }

  if (Top.jeIframe) {
    //---vsechny odkazy musi byt v iframe
    $(".product a").each(function() {
      var $href = $(this).attr("href");
      $(this).attr("href", $href + "#iframe");
    });

    var $kod =
      '<div id="dvPanelFrame"> \
                     <a class="close" href="">ZAVŘÍT NÁHLED</a> \
                   </div>';
    $($kod).appendTo("#content-wrapper");

    $("#dvPanelFrame a.close").click(function(e) {
      e.preventDefault(e);
      window.parent.$.fancybox.close();
    });
  }
} //function  upravStrankuKonfiguraceZbrane()
